import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { parseOAuthHash, jwtSub } from "../lib/oauth";
import { saveSession } from "../lib/auth-store";
import { takeStashedRedirect } from "../auth/redirect";

/** Landing route for the GoTrue OAuth redirect. Reads the session tokens from
 *  the URL fragment, stores them, and re-bootstraps the app. */
export function AuthCallback() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const result = parseOAuthHash(window.location.hash);
    if (result && "access_token" in result) {
      saveSession({
        access_token: result.access_token,
        refresh_token: result.refresh_token,
        user_id: jwtSub(result.access_token),
      });
      // A full navigation re-runs AuthProvider with the new session (and routes
      // a first-time user into profile onboarding). Return to the intended page
      // if the user arrived from a deep link (stashed before the OAuth redirect).
      window.location.assign(takeStashedRedirect());
      return;
    }
    setError(result && "error" in result ? result.error : "Sign-in was cancelled or did not complete.");
  }, []);

  return (
    <div className="mx-auto grid min-h-full max-w-sm content-center gap-4 px-6 py-16 text-center">
      {error ? (
        <>
          <h1 className="font-display text-xl font-black tracking-tight">Couldn't sign in</h1>
          <p className="font-mono text-sm text-danger">{error}</p>
          <Link to="/login" className="font-bold text-accent-strong">
            Back to sign in
          </Link>
        </>
      ) : (
        <p className="font-mono text-sm text-muted">Signing you in…</p>
      )}
    </div>
  );
}
